import ReactSelectInput from "@pathwright/ui/src/components/form/form-select/ReactSelectInput"

export { default } from "@pathwright/ui/src/components/form/form-select/ReactSelectInput"

/**
 * Adapter for forms that store a primitive option value (id/string) instead of
 * the full option object. Bridges react-connect-form Field value/onChange with
 * react-select v5's option-object contract.
 */
export function SimpleValueSelectInput({
  value,
  onChange,
  options = [],
  getOptionValue = (option) => option.value,
  getOptionLabel = (option) => option.label,
  ...props
}) {
  return (
    <ReactSelectInput
      {...props}
      options={options}
      getOptionValue={getOptionValue}
      getOptionLabel={getOptionLabel}
      value={
        options.find((option) => getOptionValue(option) === value) ?? null
      }
      onChange={(option) =>
        onChange(option != null ? getOptionValue(option) : null)
      }
    />
  )
}
